<template>
  <footer class="footer" role="contentinfo" aria-label="Site footer">
    <div class="footer-content">
      <p>&copy; <time :datetime="currentYear.toString()">{{ currentYear }}</time> PALLAS. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>


export default {
  name: "FooterPage",

  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  color: var(--textColor);
  z-index: var(--zFooter);
  box-sizing: border-box;
  padding: var(--footerPadding) var(--paddingStandard);
  min-height: var(--footerHeight);
  margin-top: auto;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--artOutlineColor) 0%, var(--sciOutlineColor) 100%);
  z-index: 1;
}

.footer-content {
  width: 100%;
  max-width: var(--maxContentWidth);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  z-index: 2;
}

.footer-content p {
  margin: 0;
  font-size: var(--labelText);
  font-weight: var(--font-weight-bold);
  line-height: 1.2;
}



@media screen and (max-width: var(--breakpointTablet)) {
  .footer {
    padding: var(--footerPadding) var(--paddingTight);
  }

  .footer-content p {
    font-size: var(--tagText);
  }
}
</style>